import React from 'react';
import { observer } from 'mobx-react';

import EventItem from 'ui/Feed/EventItem';

import { SiteManagerChangeActivityProps } from './types';

const SiteManagerChangeActivity: React.FunctionComponent<SiteManagerChangeActivityProps> = ({
  activity,
  sessionUser,
}) => {
  if (activity.manager) {
    return (
      <EventItem activity={activity} sessionUser={sessionUser} id="activity-site-manager-change">
        changed site manager to {activity.manager.name}
      </EventItem>
    );
  }
  if (activity.previousManager && activity.manager === null) {
    return (
      <EventItem activity={activity} sessionUser={sessionUser} id="activity-site-manager-removed">
        removed site manager {activity.previousManager.name}
      </EventItem>
    );
  }
  return <></>;
};

export default observer(SiteManagerChangeActivity);
